import React from "react";

export const PreviewRow: React.FC<{
  label: string;
  value: string;
  hideDivider?: boolean;
}> = ({ label, value, hideDivider }) => {
  return (
    <>
      {value ? (
        <span className="text-dark-900 line-clamp-4 jugl__break-word text-sm leading-[21px]">
          {value}
        </span>
      ) : (
        <span className="text-dark-800 font-secondary text-sm leading-[21px]">
          {label}
        </span>
      )}
      {!hideDivider && (
        <div className="bg-dark-100 my-4 h-px w-full rounded-[10px]" />
      )}
    </>
  );
};
